export const formLinkedInRedirectUri = (linkedInLoginAPI, clientId, formURL) =>
  `${linkedInLoginAPI}?client_id=${encodeURIComponent(clientId)}&formURL=${encodeURIComponent(formURL)}`;
